/*
* Created By Jaeuk Ryu <devp011>
*/
export const state = () => ({
  url: '/api/cm/vpn-branch',
  centerIpUrl: '/api/cm/vpn-branch/center-ip',
  centerObjectUrl: '/api/cm/vpn-branch/center/addr-obj',
  branchObjectUrl: '/api/cm/vpn-branch/addr-obj',
  PolicyUrl: '/api/cm/vpn-policy/device',

  editDialog: true,
  selectedDevice: {},
  defaultId: '',
  // === Table Contents  ===
  rowSelectItems: [],
  dataList: [],
  tableCondition: {
    selectedRowData: false
  },
  centerIpList: {},

  // === Popup Contents  ===
  policyOption: [
    {
      label: 'default',
      value: 'default'
    }
  ],
  defaultPolicy: {
    name: '',
    vpn_policy_id: null
  },
  // ********************************************************************************************************************
  /*  on off 에 의해서 필수값이 필수값이 아니게 된경우 다음과 같이 초기화 한다.
  Object type = [] Array type = {} Int, Ip = null String = ''
  위와 같이 초기화 하는경우는, 원본을 손대지 않고, _.CloneDeep 기능을 이용해서 변환한 데이터를 서버로 보낸다.
  0. 변환이 반드시 필요한 경우 // 뒤에 (*) 를 표시해두었다. 내용이 보기 어려운 경우 (*) 라도 주의해서 보는것이 좋다.
  1. NEED TO COVERT null
    null 이 들어올 수 있고,
    보낼 때 ON/OFF 등에 의해 필요 없게 되었을 때, null 로 변환해서 보내야 하는 경우를 표시한다.
  2. NEED TO CONVERT {} 또는 []
    들어올 때는 {} 또는 [] 가 들어올 수 있고
    보낼 때 ON/OFF 등에 의해 필요 없게 되었을 때나, 설정을 하지 않은경우,
    안에 값을 남기지 않고 {} 또는 [] 로 비워서 보내야 하는 경우를 표시한다.
  3. << KEY >> (파라미터 자신이, ON OFF 의 KEY 가 되는 경우)
  4. << parameter name >> (파라미터 자신에게 영향을 끼치는 ON OFF 의 KEY 를 기재)
  5. DEFAULT (기본값을 표시해야 하는 경우)
  6. NOT NULL (필수 항목이어서 null 로 주고 받지 않는 경우)
  7. NUM, IP (number 나 IP 타입이어서 null 로 들어올 수 있고, 보낼 때, '' 인 경우 null 로 변환해서 보내야 하는 경우)
  8. UnUsed 주고 받기는 하나 사용하지 않는 파라미터
  */
  // ********************************************************************************************************************
  detailPopUpData: {
    device_uname: '', // STRING
    vpn_branch_id: null, // NUM
    vpn_policy_id: null, // NUM
    vpn_policy_uname: null, // NUM
    vpn_branch_use_yn: 0, // NOT NULL
    vpn_branch_uname: '', // NOT NULL
    vpn_center_ip: [],
    vpn_branch_auth_type: 0, // DEFAULT, NOT NULL << KEY >> vpn_branch_auth_pw
    vpn_branch_id_val: '', // NOT NULL STRING
    vpn_branch_auth_pw: '', //  (*) NEED TO CONVERT [] NOT NULL 이지만, vpn_branch_auth_type = 1 이면 수정이나 추가할 때 지울 것.
    vpn_branch_desc: '',
    vpn_branch_inter_conn_use_yn: 0, // DEFAULT, NOT NULL
    center_addr_obj: [], // (*) NEED TO CONVERT [] << vpn_branch_inter_conn_use_yn = 0 이면 지울것 >>
    branch_addr_obj: [], // (*) NEED TO CONVERT [] << vpn_branch_inter_conn_use_yn = 0 이면 지울것 >>
    vpn_branch_conn_type: 2, // DEFAULT, NOT NULL
    vpn_branch_local_ip: null, // DEFAULT, NOT NULL 로컬 아이피는 필수값이나, 플래그가 없이 때문에 값이 있느냐 없느냐에 따라 vue 파일에서 anyStatus 계산한다.
    vpn_branch_op_type: 0, // DEFAULT, NOT NULL
    vpn_branch_lftm: 80000, // DEFAULT, NOT NULL
    vpn_branch_ike_lftm: 160000, // DEFAULT, NOT NULL
    vpn_branch_center_ike_port: 500, // DEFAULT, NOT NULL
    vpn_branch_udp_encap_yn: 0 // DEFAULT, NOT NULL
  }
})

export const mutations = {
  deviceInfo: (state, item) => {
    state.selectedDevice = item
  },
  setRowSelectItems (state, data) {
    state.rowSelectItems = data
  },
  setDialogType (state, data) {
    state.editDialog = data
  },
  clearDetailPopup (state) {
    state.detailPopUpData = {
      device_uname: '', // STRING
      vpn_branch_id: null, // NUM
      vpn_policy_id: null, // NUM
      vpn_policy_uname: null, // NUM
      vpn_branch_use_yn: 0, // NOT NULL
      vpn_branch_uname: '', // NOT NULL
      vpn_center_ip: [],
      vpn_branch_auth_type: 0, // DEFAULT, NOT NULL << KEY >> vpn_branch_auth_pw
      vpn_branch_id_val: '', // NOT NULL STRING
      vpn_branch_auth_pw: '', //  (*) NEED TO CONVERT [] NOT NULL 이지만, vpn_branch_auth_type = 1 이면 수정이나 추가할 때 지울 것.
      vpn_branch_desc: '',
      vpn_branch_inter_conn_use_yn: 0, // DEFAULT, NOT NULL
      center_addr_obj: [], // (*) NEED TO CONVERT [] << vpn_branch_inter_conn_use_yn = 0 이면 지울것 >>
      branch_addr_obj: [], // (*) NEED TO CONVERT [] << vpn_branch_inter_conn_use_yn = 0 이면 지울것 >>
      vpn_branch_conn_type: 2, // DEFAULT, NOT NULL
      vpn_branch_local_ip: null, // DEFAULT, NOT NULL 로컬 아이피는 필수값이나, 플래그가 없이 때문에 값이 있느냐 없느냐에 따라 vue 파일에서 anyStatus 계산한다.
      vpn_branch_op_type: 0, // DEFAULT, NOT NULL
      vpn_branch_lftm: 80000, // DEFAULT, NOT NULL
      vpn_branch_ike_lftm: 160000, // DEFAULT, NOT NULL
      vpn_branch_center_ike_port: 500, // DEFAULT, NOT NULL
      vpn_branch_udp_encap_yn: 0 // DEFAULT, NOT NULL
    }
  },
  getTableList (state, data) {
    state.dataList = _.cloneDeep(data)
  },
  // 사용 전체 사용/사용 안 함 적용.
  changeAllUseYn (state, data) {
    const useData = _.cloneDeep(state.dataList)
    _.forEach(useData, o => {
      o.vpn_branch_use_yn = data
    })
    state.dataList = useData
  },
  getDetailDataList: (state, data) => {
    state.detailPopUpData = data.result[0]
  },
  // getPopupDataList (state) {
  //   const num = state.dataList.findIndex(p => p.vpn_branch_id === state.rowSelectItems[0].vpn_branch_id)
  //   state.detailPopUpData = _.cloneDeep(state.dataList[num])
  //   state.centerIpList = state.detailPopUpData.center_ip.split(',')
  // },
  getPolicyData (state, data) {
    state.policyOption = []
    for (const item of data.result) {
      state.policyOption.push({
        label: item.vpn_policy_uname,
        value: item.vpn_policy_id
      })
      if (item.vpn_policy_use_yn === 1) {
        state.defaultPolicy.name = item.vpn_policy_uname
        state.defaultPolicy.vpn_policy_id = item.vpn_policy_id
      }
    }
  },
  getDefaultId (state, payload) {
    state.defaultId = parseInt(payload.msg)
  },
  syncTable: (state, {data, type}) => {
    if (type === 'edit') {
      const num = _.findIndex(state.dataList, ['vpn_branch_id', data.result.vpn_branch_id])
      data.result.conn_mode_div = data.result.vpn_branch_conn_type + ',' + data.result.div
      state.dataList.splice(num, 1, data.result)
      // state.dataList[num] = _.cloneDeep(data.result)
    } else if (type === 'add') {
      data.result.conn_mode_div = data.result.vpn_branch_conn_type + ',' + data.result.div
      state.dataList.push(_.cloneDeep(data.result))
    } else {
      for (const item of state.rowSelectItems) {
        const num = _.findIndex(state.dataList, ['vpn_branch_id', item.vpn_branch_id])
        state.dataList.splice(num, 1)
      }
    }
  }
}

export const actions = {
  // 메인 테이블
  async getTableList ({commit, state}, payload) {
    let res = {}
    try {
      let config = {loading: true, successAlert: true},
        url = `${state.url}/0/0`
      // 사용 미사용을 위한 기능
      if (payload === 'setUsed') {
        url = state.url
        config = {loading: false, successAlert: false}
      }
      res = await this.$axios.$get(url, config)
      if (res.code === 'ok') {
        commit('getTableList', res.result)
      }
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  async getDetailDataList ({commit, state}, payload = {'status': 'popup', 'deviceId': 0, 'branchId': 0}) {
    const deviceId = (payload.status === 'table') ? payload.deviceId : state.rowSelectItems[0].device_id
    const branchId = (payload.status === 'table') ? payload.branchId : state.rowSelectItems[0].vpn_branch_id
    try {
      const data = await this.$axios.$get(`${state.url}/${deviceId}/${branchId}`, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getDetailDataList', data)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async addTableList ({ store, commit, state, dispatch }, {loading = true} = {}) {
    let res = {}
    try {
      const axiosData = _.cloneDeep(state.detailPopUpData)
      if (state.detailPopUpData.vpn_branch_auth_type === 1) {
        axiosData.vpn_branch_auth_pw = ''
      } else {
        if (state.detailPopUpData.vpn_branch_auth_pw !== undefined && state.detailPopUpData.vpn_branch_auth_pw !== '') {
          axiosData.vpn_branch_auth_pw = btoa(axiosData.vpn_branch_auth_pw)
        }
      }
      if (!state.editDialog) {
        axiosData.vpn_branch_id = state.defaultId
      }
      res = await this.$axios.$put(state.url, axiosData, {loading, successAlert: false})
      if (res.code === 'ok') {
        // this.dispatch(`common/common/setIsChanged`, true)
        dispatch('common/common/setIsChanged', true, {root: true})
      }
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  async edtTableList ({store, commit, state, dispatch}) {
    let res = {}
    try {
      const axiosData = _.cloneDeep(state.detailPopUpData)
      if (state.detailPopUpData.vpn_branch_auth_type === 1) {
        axiosData.vpn_branch_auth_pw = ''
      } else {
        if (state.detailPopUpData.vpn_branch_auth_pw !== undefined && state.detailPopUpData.vpn_branch_auth_pw !== '') {
          axiosData.vpn_branch_auth_pw = btoa(axiosData.vpn_branch_auth_pw)
        }
      }
      res = await this.$axios.$put(state.url, axiosData, { successAlert: false })
      if (res.code === 'ok') {
        dispatch('common/common/setIsChanged', true, {root: true})
      }
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  async delTableList ({commit, state}, payload = false) {
    let isMulty = false
    if (state.rowSelectItems.length > 1) {
      isMulty = true
    }
    const idSet = []
    if (payload) { // 빈 ID 생성 후 빈 ID 삭제시 사용.
      idSet.push(state.defaultId)
    } else {
      for (const item of state.rowSelectItems) {
        idSet.push(item.vpn_branch_id)
      }
    }
    const idList = {'vpn_branch_id_list': idSet}
    try {
      const data = await this.$axios.$put(`${state.url}/multi`, idList, {successAlert: false})
      if (data.code !== 'ok') {
        if (isMulty) {
          return {code: 'pok', errors: data.result.msg}
        }
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getPolicyData ({commit, state}) { // 정책 목록
    try {
      const rowId = state.editDialog ? state.rowSelectItems[0].device_id : state.selectedDevice.deviceId
      const data = await this.$axios.$get(`${state.PolicyUrl}/${rowId}`, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getPolicyData', data)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 지점 설정 빈 설정 (추가시 빈 id 조회)
  async getDefaultId ({commit, state}, {loading = true} = {}) {
    let res = {}
    try {
      res = await this.$axios.$post(`${state.url}/${state.selectedDevice.deviceId}`, null, {loading, successAlert: false})
      if (res.code === 'ok') {
        commit('getDefaultId', res.result)
      }
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  // 센터 아이피 조회
  async getCenterIp ({commit, state}, {status = 'popup', id = 0, loading = true} = {}) {
    let res = {}
    try {
      let rowId = ''
      if (status === 'table') {
        rowId = id
      } else {
        rowId = state.editDialog ? state.rowSelectItems[0].vpn_branch_id : state.defaultId
      }
      res = await this.$axios.$get(`${state.centerIpUrl}/${rowId}`, {loading, successAlert: false})
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  // 센터 아이피 추가
  async addCenterIp ({commit, state}, payload = {'status': 'popup', 'id': 0, 'ip': ''}) {
    let res = {}
    try {
      let axiosData = {}
      if (payload.status === 'table') {
        axiosData = {
          'vpn_branch_id': payload.id,
          'vpn_center_ip_list': [payload.ip],
          'dup_check_yn': 1
        }
      } else {
        axiosData = {
          'vpn_branch_id': state.editDialog ? state.rowSelectItems[0].vpn_branch_id : state.defaultId,
          'vpn_center_ip_list': payload.ip
        }
      }
      res = await this.$axios.$post(state.centerIpUrl, axiosData, {successAlert: false})
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  // 센터 아이피 삭제
  async delCenterIp ({commit, state}, payload) {
    let res = {}
    try {
      const idList = {'vpn_center_ip_id_list': payload}
      res = await this.$axios.$put(state.centerIpUrl, idList, {successAlert: false})
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  // 센터 객체 조회
  async getObject ({commit, state}, {type, loading = true} = {}) {
    let res = {}
    try {
      const rowId = state.editDialog ? state.rowSelectItems[0].vpn_branch_id : state.defaultId
      const url = `${type === 'center' ? state.centerObjectUrl : state.branchObjectUrl}/${rowId}`
      res = await this.$axios.$get(url, null, {loading, successAlert: false})
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  // 센터 객체 추가
  async addObject ({commit, state}, {type, data, loading = true} = {}) {
    let res = {}
    try {
      const rowId = state.editDialog ? state.rowSelectItems[0].vpn_branch_id : state.defaultId
      const axiosData = {
        'addr_obj_id_list': data,
        'vpn_branch_id': rowId
      }
      const url = type === 'center' ? state.centerObjectUrl : state.branchObjectUrl
      res = await this.$axios.$post(url, axiosData, {loading, successAlert: false})
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  // 센터 객체  삭제
  async delObject ({commit, state}, {type, data} = {}) {
    let res = {}
    try {
      const rowId = state.editDialog ? state.rowSelectItems[0].vpn_branch_id : state.defaultId
      const idList = {
        'addr_obj_id_list': data,
        'vpn_branch_id': rowId
      }
      const url = type === 'center' ? state.centerObjectUrl : state.branchObjectUrl
      res = await this.$axios.$put(url, idList, {successAlert: false})
      return res
    } catch (e) {
      res = {
        code: 'nok',
        result: {
          msg: e.message
        }
      }
      return res
    }
  },
  async usedSetting ({commit, state, dispatch}, payload) { // 멀티 수정 기능은 POK 시는 재조회, 아닌경우는 그대로 처리.
    const idList = []
    if (payload.status === 'header') {
      for (const item of state.dataList) {
        idList.push([item.vpn_branch_id, payload.data])
      }
    } else if (payload.status === 'row') {
      const getId = state.rowSelectItems[0].vpn_branch_id
      idList.push([getId, payload.data])
    }

    try {
      const data = await this.$axios.$post(`${state.url}/multi`, {vpn_branch_use_list: idList}, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        if (payload.status === 'row') {
          return {code: 'nok', errors: data.result.msg}
        }
        return {code: 'pok', errors: data.result.errors}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    // 별도로 commit 하는 정책으로 유지
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.url}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}

export const getters = {}
export const strict = false
